export class NuevoEncargadoDTO {
    constructor(
        public nrRut: number,
        public dv: string,
        public nombres: string,
        public apellidos: string,
        public permisos:PermisosDTO,
        public email:string
    ){
        this.nrRut=nrRut;
        this.dv=dv;
        this.nombres=nombres;
        this.apellidos=apellidos;
        this.permisos=permisos;
        this.email=email;
    }
}

export class PermisosDTO{
    constructor(
        public puedeCotizar: boolean,
        public puedeComprar: boolean,
        public puedeRecibir: boolean,
    ){
        this.puedeCotizar=puedeCotizar;
        this.puedeComprar=puedeComprar;
        this.puedeRecibir=puedeRecibir;
    }
}

